import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { useNavigate } from "react-router-dom";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { tasksId } from "../../../types/activityTasks";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { PanelInstrucionHands } from "../../../components/common/PanelInstrucionHands";
import { imgInstruction } from "../../../assets/imgIntruction";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { BarStatusActivies } from "../../../components/common/BarStatusActivies";
import { audiosAssets } from "../../../assets/audio";
import { voicesTypeControl } from "../../../types/audioType";
import { ButtonReturn } from "../../../components/common/ButtonReturn";

const steps = {
	dialogInitial: 1,
	viewActivities: 100,
	dialogTwo: 2,
	dialogThree: 3,
	dialogFour: 4,
	dialogFive: 5,
	dialogSix: 6,
	dialogSeven: 7,
	dialog8: 20,
	dialog9: 21, // mensajes
	dialog9Extra: 30, // mensajes
	dialog10: 22, // panel
	modalsubactivityOne: 8, // panel
	modalsubactivityTwo: 10, // panel
	gamesubactivityOne: 9, // juego
	game: 500,
	win: 888,
	fail: 999,
};

export const SubtopicFourActivityTwo = () => {
	const navigator = useNavigate();
	const dispatch = useDispatch();
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema1.activities.subtema4], 2);

	useEffect(() => {
		if (loaded) {
			console.log("subtema 4 Activity Two");
			ObserverEmitter.emit(EVENTS.subtopicFour.initScene, 2);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub04.sub4_act2_a01)
	})

	ObserverEmitter.on(EVENTS.subtopicFour.activityTwo.winActivity, () => {
		setUiToShow(steps.win);
	});

	ObserverEmitter.on(EVENTS.subtopicFour.activityTwo.failActivity, () => {
		setUiToShow(steps.fail);
	});
	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, -1].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.subtopicFour.initScene, 2);
						setUiToShow(1)
					}} />
				)}
			</>
			{uiToShow === steps.dialogInitial && (
				<DialogBarNew
					titulo="Datti Andatti"
					dialog={
						"Ahora hablaremos de los PAR (Productos de Alto Riesgo), los cuáles son el dinero, vino, cigarros, tarjetas y teléfonos celulares."
					}
					percentage={"10%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
						ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
						setUiToShow(steps.viewActivities);
					}}
				></DialogBarNew>
			)}

			{steps.viewActivities === uiToShow && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 3: Etiquetado."
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub04.sub4_act2_a02)
							ObserverEmitter.emit(EVENTS.characterAnimations.saludo);
							setUiToShow(steps.dialogTwo);
						}}
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === steps.dialogTwo && (
				<>
					<BarStatusActivies activities={tasksList} />
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={"Debido a su alto valor, es importante contar con medidas preventivas y cumplir con los protocolos de seguridad."}
						percentage={"20%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub04.sub4_act2_a03)
							ObserverEmitter.emit(EVENTS.subtopicFour.activityTwo.onAnimateUSB);
							ObserverEmitter.emit(EVENTS.subtopicFour.activityTwo.visibleObjetProductsOnly, "Celular");
							setUiToShow(steps.dialogThree);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogThree && (
				<>
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={"Para los celulares, procura exhibir únicamente la carcaza y mantener cerrados los exhibidores."}
						percentage={"30%"}
						whitImg={true}
						callback={() => {
							ObserverEmitter.emit(EVENTS.subtopicFour.activityTwo.onAnimateCigarros);
							ObserverEmitter.emit(EVENTS.subtopicFour.activityTwo.visibleObjetProductsOnly, "Cigarros");

							setUiToShow(steps.dialogFour);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogFour && (
				<>
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={"Para los cigarros, procura exhibir la cajetilla en la cigarrera, resguardando el resto en la jaula."}
						percentage={"40%"}
						whitImg={true}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub04.sub4_act2_a04)
							ObserverEmitter.emit(EVENTS.subtopicFour.activityTwo.onAnimateBotellas);
							ObserverEmitter.emit(EVENTS.subtopicFour.activityTwo.visibleObjetProductsOnly, "Botella_1");
							setUiToShow(steps.dialogFive);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogFive && (
				<>
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={
							"Para los vinos de alto valor, procura exhibir los empaques vacíos y resguarda el vino en la jaula de resguardo. En caso de no contar con caja, exhibe un solo producto."
						}
						percentage={"40%"}
						whitImg={true}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub04.sub4_act2_a06)
							ObserverEmitter.emit(EVENTS.subtopicFour.activityTwo.onAnmateDinero);
							ObserverEmitter.emit(EVENTS.subtopicFour.activityTwo.visibleObjetProductsOnly, "Dinero_1");
							setUiToShow(steps.dialogSeven);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogSeven && (
				<>
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={
							"Para el dinero, procura realizar retiros parciales inmediatos o después de cobrar corresponsalías superiores a $1,000.00 (mil pesos)."
						}
						percentage={"60%"}
						whitImg={true}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub04.sub4_act2_a07)
							ObserverEmitter.emit(EVENTS.subtopicFour.activityTwo.killAllAnimations);
							ObserverEmitter.emit(EVENTS.subtopicFour.activityTwo.visibleObjetProductsAll);
							setUiToShow(steps.dialog8);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialog8 && (
				<>
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={"No guardes efectivo en las bolsas del chaquetín. No expongas morralla en un solo lugar del área de cajas."}
						percentage={"70%"}
						whitImg={true}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub04.sub4_act2_a08)
							setUiToShow(steps.dialog9);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialog9 && (
				<>
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={"Recuerda que toda la mercancía PAR, debe ser resguardada en la herramienta de seguridad instalada en la bodega."}
						percentage={"80%"}
						whitImg={true}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub04.sub4_act2_a09)
							setUiToShow(steps.dialog9Extra);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialog9Extra && (
				<>
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={"Selecciona los objetos y colócalos en el lugar donde deben ser resguardados."}
						percentage={"80%"}
						whitImg={true}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.modalsubactivityOne);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.modalsubactivityOne && (
				<PanelInstrucionHands
					text="Toca encima de el producto que desees acomodar..."
					action={() => {
						setUiToShow(steps.modalsubactivityTwo);
					}}
					img={imgInstruction.sub4_act_2_01}
				/>
			)}
			{uiToShow === steps.modalsubactivityTwo && (
				<PanelInstrucionHands
					text="Toca encima sobre el lugar donde deseas acomodarlos."
					action={() => {
						ObserverEmitter.emit(EVENTS.subtopicFour.activityTwo.initActovity);
						setUiToShow(steps.game);
					}}
					img={imgInstruction.sub4_act_2_02}
				/>
			)}
			{uiToShow === steps.win && (
				<ValidationResultModal
					title="¡Bien hecho!"
					numberPoints={15}
					dialogModal="Recuerda que los PAR deben ser resguardados en la herramienta de seguridad instalada en la bodega."
					buttonTxt="Continuar"
					isCorrect={true}
					action={() => {
						dispatch(
							completeOneTask({
								idActivity: 2,
								pointsWin: 15,
								subtema: tasksId.tema1.activities.subtema4,
							})
						);
						navigator("/home1/tema1/subtema4/activityresult");
					}}
				/>
			)}
			{uiToShow === steps.fail && (
				<ValidationResultModal
					title="Respuesta incorrecta."
					dialogModal="Tu seguridad es importante. El acomodo de cada uno de estos productos debe ser el adecuado."
					buttonTxt="Continuar"
					isCorrect={false}
					action={() => {
						dispatch(
							completeOneTask({
								idActivity: 2,
								pointsWin: 5,
								subtema: tasksId.tema1.activities.subtema4,
							})
						);
						navigator("/home1/tema1/subtema4/activityresult");
					}}
				/>
			)}
		</>
	);
};
